import { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const ArrowGreaterThan: FC<IconProps> = ({ width = 27, height = 22, fill = '#111026', className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.39 5.71C9.52 5.8 9.68 5.99 9.8 6.1L10.76 7.01L13.52 9.65L14.41 10.5C14.58 10.67 14.75 10.84 14.94 11C14.71 11.19 14.51 11.41 14.3 11.61L13.08 12.77L9.47 16.22L9.39 16.29C9.29 16.17 9.17 16.06 9.07 15.95C8.86 15.73 8.65 15.51 8.44 15.29C8.95 14.83 9.44 14.34 9.94 13.86L12.94 11C12.64 10.71 12.33 10.42 12.03 10.13L10.35 8.53L9.11 7.35C8.89 7.13 8.67 6.91 8.44 6.71C8.76 6.38 9.07 6.05 9.39 5.71Z"
        fill="white"
      />
    </svg>
  );
};
